import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormatCurrencys } from '../../utils/commonUtil';
import { APPROVE } from '../../utils/commonType';
import PermissionWrapper from '../common/PermissionWrapper';

const RecordAndSelect = ({
	totalRecord = 0,
	sumRecord = [],
	perPage = 10,
	onChange,
	options = [],
	label,
	selectable = false,
	showConfirmButton = true,
	selectedIds = [],
	handleConfirmSelected,
	clearSelected,
	confirmButtonLabel = "Confirm",
}) => {
	const { t } = useTranslation();
	const resolvedLabel = label || t("uiLabels.show");
	const defaultOptions = [
		{ label: '10', value: 10 },
		{ label: '20', value: 20 },
		{ label: '30', value: 30 },
		{ label: '50', value: 50 },
		{ label: '100', value: 100 },
		{ label: '1,000', value: 1000 },
		{ label: '10,000', value: 10000 },
		{ label: '100,000', value: 100000 },
		{ label: '1,000,000', value: 1000000 },
	];

	const mergedOptions = options.length > 0 ? options : defaultOptions;
	const sumText = sumRecord.length > 0
		? sumRecord
			.map((obj) => {
				const key = Object.keys(obj)[0];
				const value = obj[key];
				return `${t('sumCol.' + key)} ${FormatCurrencys(value)} ${t('currentcy.kip')}`;
			})
			.join(', ')
		: '';
	return (
		<div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2 default-form">
			<label className="mb-0">
				{`${t("uiLabels.recordCount", { record: totalRecord.toLocaleString() })}, `}
				{sumText ? `${sumText}` : ''}
			</label>
			{selectable && (
				<div
					className="d-flex align-items-center gap-2 mb-2 flex-wrap"
					style={{ rowGap: '8px', columnGap: '8px' }}
				>
					<div>
						<strong>{t("selected") || "Selected"}:</strong> {selectedIds.length}
					</div>
					<PermissionWrapper permission={APPROVE}>
						{showConfirmButton && <button
							type="button"
							className="btn btn-primary btn-sm"
							onClick={handleConfirmSelected}
							disabled={selectedIds.length === 0}
						>
							{t(confirmButtonLabel)}
						</button>}

						<button
							type="button"
							className="btn btn-outline-secondary btn-sm"
							onClick={clearSelected}
							disabled={selectedIds.length === 0}
						>
							{t("button.clear") || "Clear"}
						</button>
					</PermissionWrapper>

				</div>
			)}
			<div className="d-flex align-items-center gap-2 form-group">
				<label className="form-label mb-0">{resolvedLabel}</label>
				<select
					className="form-select select-filter"
					style={{ width: '100px' }}
					value={perPage}
					onChange={onChange}
				>
					{mergedOptions.map((item, idx) => (

						totalRecord + 10 >= item.value ? <option key={idx} value={item.value}>
							{item.label}
						</option> : idx == 0 && totalRecord + 10 < item.value ? <option key={1} value={totalRecord}>
							{item.label}
						</option> : totalRecord + 10 >= item.value && idx != 0 && <option key={idx} value={item.value}>
							{item.label}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

export default RecordAndSelect;
